// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--3DP8t","content":"Footer-module--content--26S1q","copyright":"Footer-module--copyright--xbP5c"};